import { Controller } from "@hotwired/stimulus"
import { Tab } from "@assemblyvoting/electa-ui"

export default class extends Controller {
  private readonly onShownBound = this.onShown.bind(this)
  private readonly syncFromHashBound = this.syncFromHash.bind(this)

  connect() {
    this.tabLinks.forEach(tabLink => tabLink.addEventListener("shown.bs.tab", this.onShownBound))
    window.addEventListener("hashchange", this.syncFromHashBound)
    this.syncFromHash()
  }

  disconnect() {
    this.tabLinks.forEach(tabLink => tabLink.removeEventListener("shown.bs.tab", this.onShownBound))
    window.removeEventListener("hashchange", this.syncFromHashBound)
  }

  private get tabLinks(): HTMLAnchorElement[] {
    return Array.from(this.element.querySelectorAll('a[data-bs-toggle="tab"][href^="#"]'))
  }

  private syncFromHash() {
    const hash = window.location.hash.toLowerCase()
    if (!hash) return

    const matchingTab = this.tabLinks.find(tabLink => tabLink.getAttribute("href")?.toLowerCase() === hash)
    if (!matchingTab || matchingTab.classList.contains("active")) return

    Tab.getOrCreateInstance(matchingTab).show()
  }

  private onShown(event: Event) {
    const tabLink = event.target as HTMLAnchorElement | null
    const hash = tabLink?.getAttribute("href")
    if (!hash?.startsWith("#")) return

    window.history.replaceState(null, "", `${window.location.pathname}${window.location.search}${hash}`)
  }
}
